import { LitElement, html, utils } from '@hh/global.js'

class HHHeader extends LitElement {
  constructor() {
    super()
    this.isLoggedIn = false
    this.listId = ''
    this.wishlistStatus = JSON.parse(localStorage.getItem('wishlistStatus')) || { filled: false }
  }

  connectedCallback() {
    super.connectedCallback()
    if (!this.wishlistStatus.filled) {
      this.checkLoginStatus()
    } else {
      if(!document.querySelector('.header__utility-wishlist')) return;
      document.querySelector('.header__utility-wishlist').classList.add('is-filled')
    }
  }

  checkLoginStatus() {
    const onSwymLoadCallback = (swat) => {
      this.swat = swat

      const onSuccess = (response) => {
        this.isLoggedIn = response?.status === 'success' ? true : false
        const { data } = response
        if (data?.length > 0) {
          this.listId = data[0].lid
          this.checkWishlistStatus()
        } else {
          this.listId = null
        }
      }

      const onError = (error) => {
        console.log("Error while fetching user lists", error)
      }

      swat.wishlist?.fetchUserLists(onSuccess, onError)
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }
    window.SwymCallbacks.push(onSwymLoadCallback)

    this.isLoggedIn = Shopify.customer ? true : false
  }

  async checkWishlistStatus() {
    const listConfig = {
      "lid": this.listId,
    }

    const onSuccess = (listContents) => {
      this.updateWishlistStatus(listContents.length > 0)
      this.requestUpdate()
    }

    const onError = (error) => {
      console.log("Error fetching List Contents", error)
    }

    this.swat.fetchListCtx(listConfig, onSuccess, onError)
  }

  updateWishlistStatus(isFilled) {
    this.wishlistStatus.filled = isFilled
    localStorage.setItem('wishlistStatus', JSON.stringify(this.wishlistStatus))
    const wishlistIcon = document.querySelector('.header__utility-wishlist')
    if (wishlistIcon) {
      isFilled
        ? wishlistIcon.classList.add('is-filled')
        : wishlistIcon.classList.remove('is-filled')
    }
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    if (this.miniCart) {
      this.miniCart.toggle()
    }
  }

  get miniCart() {
    return document.querySelector('hh-mini-cart')
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
    ></slot>`
  }
}

if (!customElements.get('hh-header')) {
  customElements.define('hh-header', HHHeader);
}